export type WorkType = "movie" | "tv";

export interface Work {
  id: string;
  title: string;
  type: WorkType;
  genres: string[];
  region: string;
  year: number;
  status: string;
  rating: number;
  views: number;
  director: string;
  cast: string[];
  duration: string;
  poster: string;
  wide: string;
  summary: string;
  synopsis: string[];
  tags: string[];
}

export const works: Work[] = [
  {
    id: "huanying-jiadao",
    title: "女友的妈妈：迟到的家宴",
    type: "movie",
    genres: ["剧情", "家庭"],
    region: "中国大陆",
    year: 2025,
    status: "已上线 · 高清版",
    rating: 9.1,
    views: 386000,
    director: "陈砚舟",
    cast: ["周婉宁", "李承泽", "许清芷", "高致远"],
    duration: "118 分钟",
    poster: "https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20poster%20in%20deep%20navy%20blue%20tones%20with%20two%20elegant%20seated%20women%20silhouettes%20at%20a%20dinner%20table%20warm%20orange%20lamp%20glow%2C%20moody%20dramatic%20lighting%2C%20soft%20film%20grain%2C%20minimal%20editorial%20composition%2C%20no%20text&width=600&height=840&seq=gmw-poster-01&orientation=portrait",
    wide: "https://readdy.ai/api/search-image?query=A%20wide%20cinematic%20still%20of%20a%20traditional%20Chinese%20family%20dining%20room%20at%20dusk%2C%20long%20wooden%20table%20with%20warm%20orange%20lantern%20light%2C%20deep%20navy%20blue%20shadows%2C%20rain%20outside%20the%20window%2C%20atmospheric%20filmic%20color%20grading%2C%20no%20people%2C%20no%20text&width=1600&height=900&seq=gmw-wide-01&orientation=landscape",
    summary: "一场迟到十年的家宴，让准女婿第一次真正看清这个家庭藏在笑意背后的裂痕。",
    synopsis: [
      "林秋辞与女友沈知微交往三年，却始终没有见过她的母亲。某个雨夜，他终于被邀请到城南的老宅参加一场迟到的家宴。老宅的餐桌摆满了四副碗筷，却只有两个人入座。",
      "女友的妈妈沈婉宁是一位退休的电影放映员，谈吐从容，笑意温和，却在每次提起丈夫时悄悄转移话题。随着一道道菜品上桌，尘封多年的往事被一点点掀开：一场错过的首映、一张没有寄出的车票、以及一个一直站在门口的陌生男人。",
      "影片以克制的镜头语言和细腻的情绪铺陈，讲述两代人对家庭、体面与和解的不同理解。当最后一道甜品端上桌时，林秋辞终于明白，这顿家宴从来不是为了让谁满意，而是为了把一个家重新讲完。",
    ],
    tags: ["家庭伦理", "两代关系", "老宅", "细腻情绪"],
  },
  {
    id: "yuwang-qiutian",
    title: "雨巷里的约定",
    type: "tv",
    genres: ["都市", "情感"],
    region: "中国大陆",
    year: 2024,
    status: "全 24 集 · 完结",
    rating: 8.8,
    views: 512000,
    director: "韩知远",
    cast: ["沈知微", "韩知远", "苏念白", "沈婉宁"],
    duration: "45 分钟 / 集",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20poster%20of%20a%20young%20woman%20with%20a%20clear%20umbrella%20standing%20in%20a%20rainy%20old%20alley%2C%20deep%20blue%20rainy%20tones%20with%20a%20single%20warm%20orange%20street%20lamp%2C%20soft%20bokeh%2C%20melancholic%20film%20still%20aesthetic%2C%20no%20text&width=600&height=840&seq=gmw-poster-02&orientation=portrait",
    wide: "https://readdy.ai/api/search-image?query=Rainy%20old%20Chinese%20alley%20with%20wet%20cobblestone%20street%20and%20warm%20orange%20lamps%20reflecting%20in%20puddles%2C%20deep%20navy%20blue%20atmosphere%2C%20cinematic%20wide%20shot%2C%20lonely%20umbrella%20left%20by%20a%20doorway%2C%20filmic%20grain%2C%20no%20text&width=1600&height=900&seq=gmw-wide-02&orientation=landscape",
    summary: "一部横跨十五年的都市情感剧，从一条雨巷开始，也终将在雨巷里给出答案。",
    synopsis: [
      "十五年前，少女沈知微在雨巷里把一把伞让给了一个陌生的男孩，从此她的生活轨迹被悄然改写。十五年后，她带着母亲沈婉宁的旧剧本回到这座城市，成为一名剧本修复师。",
      "剧本中记录的是一段从未拍摄完成的爱情故事，而故事里的人，似乎都能在她的身边找到影子：固执的老邻居、沉默的放映员、在楼下等了一整夜的男人。",
      "剧集采用双时间线交叉叙事，一半是当下的城市日常，一半是旧剧本里的黑白青春。在最后一集中，沈知微终于走回那条雨巷，而伞下的人，已经等了很多年。",
    ],
    tags: ["都市情感", "双时间线", "旧城", "治愈"],
  },
  {
    id: "sanlou-dengpao",
    title: "三楼的灯总是亮着",
    type: "movie",
    genres: ["悬疑", "剧情"],
    region: "中国香港",
    year: 2025,
    status: "已上线 · 4K 修复",
    rating: 8.5,
    views: 274000,
    director: "梁世衡",
    cast: ["梁世衡", "许清芷", "钟楚言"],
    duration: "106 分钟",
    poster: "https://readdy.ai/api/search-image?query=Suspenseful%20cinematic%20poster%20of%20a%20narrow%20apartment%20building%20staircase%20at%20night%2C%20one%20lit%20window%20on%20the%20third%20floor%20glowing%20warm%20orange%2C%20deep%20navy%20shadows%2C%20mysterious%20mood%2C%20vertical%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=840&seq=gmw-poster-03&orientation=portrait",
    wide: "https://readdy.ai/api/search-image?query=Old%20Hong%20Kong%20apartment%20buildings%20at%20night%20seen%20from%20a%20rooftop%2C%20one%20window%20glowing%20warm%20orange%2C%20deep%20navy%20blue%20neon%20reflections%2C%20misty%20mood%2C%20cinematic%20wide%20suspense%20scene%2C%20no%20text&width=1600&height=900&seq=gmw-wide-03&orientation=landscape",
    summary: "每到深夜三楼的那盏灯都会亮起，而楼里的住户都说，那里早已没人住了。",
    synopsis: [
      "搬进旧楼的第一晚，实习记者阿澄发现对面三楼有一盏灯在凌晨两点准时亮起。楼下的杂货店老板告诉她，那户人家十年前就搬走了。",
      "随着调查深入，阿澄发现整栋楼的住户都在刻意回避同一个年份，而她的房东，正是当年那件事唯一的目击者。",
      "影片用大量固定长镜头营造压迫感，把一个关于目击与沉默的故事，压缩在四十八小时的雨夜里。真相揭开时，灯依然亮着。",
    ],
    tags: ["悬疑推理", "都市怪谈", "旧楼", "真相"],
  },
  {
    id: "dishifang-jian",
    title: "第十坊间",
    type: "tv",
    genres: ["古装", "悬疑"],
    region: "中国大陆",
    year: 2023,
    status: "全 32 集 · 完结",
    rating: 8.9,
    views: 663000,
    director: "陆行舟",
    cast: ["祁砚", "苏念白", "顾南衣", "沈婉宁"],
    duration: "48 分钟 / 集",
    poster: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20period%20drama%20poster%20of%20a%20scholar%20in%20dark%20navy%20robes%20holding%20a%20lantern%20in%20a%20moonlit%20courtyard%2C%20warm%20orange%20lantern%20light%2C%20ink%20wash%20atmosphere%2C%20vertical%20cinematic%20composition%2C%20no%20text&width=600&height=840&seq=gmw-poster-04&orientation=portrait",
    wide: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20lamp-lit%20alley%20at%20night%20with%20wooden%20lanterns%20hanging%2C%20warm%20orange%20glow%20against%20deep%20indigo%20sky%2C%20mist%20between%20tiled%20roofs%2C%20cinematic%20period%20drama%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=gmw-wide-04&orientation=landscape",
    summary: "长安城第十坊的一桩旧案，牵出三个家族二十年的隐秘往来。",
    synopsis: [
      "大唐年间，第十坊的一口井里捞出一只不属于这个年代的漆盒，盒中是一封写于二十年后的信。主簿祁砚奉命查案，却发现信里的每一个名字，都与身边的同僚有关。",
      "剧集以单元案件串联主线，每一坊一案，最终收束于二十年前那场未被记载的火灾。人物关系错综复杂，台词考究，服化道还原度高。",
      "在收官集中，祁砚站在修复后的坊门前说：「有些案子不是用来破的，是用来记住的。」",
    ],
    tags: ["古装悬疑", "单元探案", "长安", "群像"],
  },
  {
    id: "changan-yeyu",
    title: "长夜与灯",
    type: "movie",
    genres: ["战争", "历史"],
    region: "中国大陆",
    year: 2022,
    status: "已上线 · 导演剪辑版",
    rating: 9.0,
    views: 421000,
    director: "郑泊远",
    cast: ["高致远", "梁世衡", "钟楚言", "周婉宁"],
    duration: "142 分钟",
    poster: "https://readdy.ai/api/search-image?query=Epic%20historical%20war%20film%20poster%20with%20a%20lone%20figure%20silhouette%20holding%20a%20lantern%20on%20a%20snowy%20ridge%20at%20night%2C%20deep%20navy%20blue%20tones%20with%20a%20single%20warm%20orange%20light%2C%20dramatic%20minimal%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=840&seq=gmw-poster-05&orientation=portrait",
    wide: "https://readdy.ai/api/search-image?query=Epic%20snowy%20mountain%20ridge%20at%20night%20under%20a%20deep%20indigo%20sky%2C%20small%20glowing%20orange%20lanterns%20moving%20along%20a%20long%20path%2C%20historical%20war%20film%20atmosphere%2C%20vast%20scale%2C%20misty%20air%2C%20no%20text&width=1600&height=900&seq=gmw-wide-05&orientation=landscape",
    summary: "一支护送队伍穿越三百里雪原，只为把一盏灯送到天亮之前。",
    synopsis: [
      "战乱年代，一支由七人组成的护送队伍接下一项任务：在天亮之前，把一盏特制的灯送到三百里外的山城。灯不是武器，却是唯一能让人相信天还会亮的证据。",
      "影片以极简的场景和缓慢的节奏推进，把大量篇幅留给风雪、脚步和沉默的对话。每个人都在路上交代了自己最后一段过去。",
      "当灯终于在山城点亮时，队伍只剩下两人。影片没有给出胜利的欢呼，只有远处缓缓升起的晨光。",
    ],
    tags: ["历史战争", "风雪", "群像", "信仰"],
  },
  {
    id: "jinxiu-yuan",
    title: "锦绣园旧事",
    type: "tv",
    genres: ["年代", "家庭"],
    region: "中国台湾",
    year: 2021,
    status: "全 18 集 · 完结",
    rating: 8.4,
    views: 198000,
    director: "柯明川",
    cast: ["许清芷", "沈婉宁", "苏念白"],
    duration: "52 分钟 / 集",
    poster: "https://readdy.ai/api/search-image?query=Nostalgic%20period%20family%20drama%20poster%20of%20an%20old%20Taiwanese%20garden%20courtyard%20with%20a%20woman%20in%20a%20pale%20qipao%20looking%20at%20a%20photo%20album%2C%20warm%20orange%20afternoon%20light%20and%20deep%20teal%20shadows%2C%20vertical%20cinematic%20composition%2C%20no%20text&width=600&height=840&seq=gmw-poster-06&orientation=portrait",
    wide: "https://readdy.ai/api/search-image?query=Old%20taiwanese%20garden%20courtyard%20in%20late%20afternoon%20light%2C%20terracotta%20tiles%20and%20greenery%2C%20warm%20orange%20sunlight%20with%20long%20shadows%20and%20deep%20teal%20shade%2C%20nostalgic%20cinematic%20period%20scene%2C%20no%20text&width=1600&height=900&seq=gmw-wide-06&orientation=landscape",
    summary: "一座老园子、三代女人的日记，把台湾四十年的家事慢慢讲完。",
    synopsis: [
      "锦绣园是一座即将被拆除的老宅，最后一个住户是七十岁的绣娘阿缎。拆迁之前，她决定把祖母留下的三本日记读给孙女听。",
      "日记从战后写到解严，从一件旗袍写到一间裁缝铺，三代女性用各自的方式撑起这个家。剧集用缓慢的节奏与大量生活细节，把时代压缩进一顿饭、一件衣服、一句没能说完的话。",
      "最后一集里，园子还是被拆了，但阿缎把那棵树下的土装进了一只旧罐子，带着它搬进了新公寓。",
    ],
    tags: ["年代家庭", "女性群像", "日记", "岛屿记忆"],
  },
  {
    id: "wuren-zhixiao",
    title: "午夜剧场",
    type: "movie",
    genres: ["文艺", "剧情"],
    region: "日本",
    year: 2024,
    status: "已上线 · 特别版",
    rating: 8.7,
    views: 156000,
    director: "中村悠真",
    cast: ["中村悠真", "周婉宁", "高致远"],
    duration: "97 分钟",
    poster: "https://readdy.ai/api/search-image?query=Minimal%20arthouse%20film%20poster%20of%20an%20empty%20small%20cinema%20with%20rows%20of%20velvet%20seats%20and%20a%20warm%20orange%20projector%20beam%20cutting%20through%20deep%20navy%20darkness%2C%20dust%20particles%20in%20the%20light%2C%20vertical%20composition%2C%20no%20text&width=600&height=840&seq=gmw-poster-07&orientation=portrait",
    wide: "https://readdy.ai/api/search-image?query=Empty%20small%20arthouse%20cinema%20auditorium%20with%20a%20warm%20orange%20projector%20beam%20through%20deep%20navy%20darkness%2C%20empty%20velvet%20seats%2C%20dust%20in%20the%20light%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=gmw-wide-07&orientation=landscape",
    summary: "一家即将关门的午夜影院，最后一个放映员决定再放一场没有观众的旧片。",
    synopsis: [
      "东京郊区的一间小影院经营了四十年，最后一天只卖出两张票。放映员佐藤决定按惯例通宵放映，把祖父留下的那卷未命名胶片作为散场片。",
      "两名观众在黑暗里逐渐发现，胶片里出现的正是这间影院本身：四十年前的座位、四十年前的人、以及一个从座位上回头看着镜头的女人。",
      "影片没有解释这一切，只是让最后一个镜头停在空荡的观众席上。灯亮之后，影院已经关门了。",
    ],
    tags: ["文艺片", "影院", "胶片", "时间"],
  },
  {
    id: "guifan-shenghuo",
    title: "规范生活",
    type: "tv",
    genres: ["都市", "职场"],
    region: "中国大陆",
    year: 2025,
    status: "更新至 12 集 · 热播",
    rating: 8.2,
    views: 233000,
    director: "简怀之",
    cast: ["顾南衣", "祁砚", "李承泽"],
    duration: "42 分钟 / 集",
    poster: "https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20poster%20of%20a%20young%20man%20in%20a%20neat%20grey%20suit%20standing%20among%20a%20grid%20of%20identical%20office%20cubicles%2C%20cool%20navy%20tones%20with%20one%20warm%20orange%20desk%20lamp%2C%20clean%20graphic%20composition%2C%20no%20text&width=600&height=840&seq=gmw-poster-08&orientation=portrait",
    wide: "https://readdy.ai/api/search-image?query=Modern%20open%20plan%20office%20at%20night%20with%20rows%20of%20cold%20navy%20blue%20monitors%20and%20one%20warm%20orange%20desk%20lamp%20still%20on%2C%20long%20empty%20desks%2C%20cinematic%20wide%20shot%20with%20quiet%20loneliness%2C%20no%20text&width=1600&height=900&seq=gmw-wide-08&orientation=landscape",
    summary: "一个把生活排进表格的男人，遇上一个从不按计划出现的女孩。",
    synopsis: [
      "三十岁的项目经理程一舟有二十七张按时间排序的清单，从早餐到遗嘱全部规划完毕。直到新同事把一个打乱他所有表格的提案放到了晨会上。",
      "剧集用轻喜剧的方式讨论当代年轻人的秩序焦虑：如何定义成功、如何接受意外、如何在表格之外留一行空白。",
      "在最新一集中，程一舟第一次删掉了自己坚持了七年的日程表，然后去吃了一顿没有预约的晚饭。",
    ],
    tags: ["都市职场", "轻喜剧", "秩序感", "当代青年"],
  },
  {
    id: "hai-an-xian",
    title: "海岸线",
    type: "movie",
    genres: ["青春", "剧情"],
    region: "中国大陆",
    year: 2023,
    status: "已上线 · 高清版",
    rating: 8.3,
    views: 142000,
    director: "林见野",
    cast: ["苏念白", "顾南衣", "钟楚言"],
    duration: "112 分钟",
    poster: "https://readdy.ai/api/search-image?query=Coming%20of%20age%20film%20poster%20of%20two%20teenagers%20sitting%20on%20a%20sea%20wall%20at%20dusk%20facing%20away%2C%20deep%20blue%20sea%20and%20warm%20orange%20sunset%20horizon%2C%20soft%20grain%20analog%20photography%20feel%2C%20vertical%20composition%2C%20no%20text&width=600&height=840&seq=gmw-poster-09&orientation=portrait",
    wide: "https://readdy.ai/api/search-image?query=Quiet%20seaside%20town%20coastline%20at%20golden%20hour%20with%20a%20long%20empty%20concrete%20sea%20wall%2C%20deep%20blue%20ocean%20meeting%20a%20warm%20orange%20sunset%2C%20gentle%20waves%2C%20nostalgic%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=gmw-wide-09&orientation=landscape",
    summary: "高考结束的那个夏天，两个少年沿着海岸线走了整整一夜，只为说清一句再见。",
    synopsis: [
      "小镇少年周野和转学生阿棠约好高考后一起看海，可成绩出来的那个下午，阿棠拿到了离开的车票。",
      "影片用一整夜的徒步串起两人的回忆：学校的广播站、废弃的渡口、存了很久的零钱罐。他们聊志愿、聊父母、聊那些明明知道不会实现的事。",
      "天亮时两人在海堤尽头分手，没有拥抱也没有眼泪，只有阿棠说的一句「以后别熬夜」。",
    ],
    tags: ["青春成长", "海边", "夏天", "告别"],
  },
  {
    id: "bailu-yuan",
    title: "白露园谶",
    type: "tv",
    genres: ["古装", "情感"],
    region: "韩国",
    year: 2024,
    status: "全 20 集 · 完结",
    rating: 8.6,
    views: 289000,
    director: "金度延",
    cast: ["许清芷", "祁砚", "苏念白", "顾南衣"],
    duration: "60 分钟 / 集",
    poster: "https://readdy.ai/api/search-image?query=Korean%20sageuk%20drama%20poster%20of%20a%20woman%20in%20traditional%20navy%20robes%20standing%20in%20a%20moonlit%20courtyard%20with%20white%20flowers%20and%20a%20warm%20orange%20lantern%2C%20elegant%20restrained%20mood%2C%20vertical%20cinematic%20composition%2C%20no%20text&width=600&height=840&seq=gmw-poster-10&orientation=portrait",
    wide: "https://readdy.ai/api/search-image?query=Korean%20royal%20palace%20courtyard%20at%20night%20with%20white%20blossom%20trees%20and%20rows%20of%20warm%20orange%20paper%20lanterns%2C%20deep%20navy%20blue%20sky%2C%20mist%20over%20stone%20paths%2C%20elegant%20period%20drama%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=gmw-wide-10&orientation=landscape",
    summary: "王宫里的白露园每到秋天就会开一种不该开的花，而看到它的人都会忘记一个人。",
    synopsis: [
      "宫中旧园白露园每逢白露便开花，宫人们传说闻过花香的人会忘记自己最想记住的人。当朝中一位老臣在花下失踪，尚宫之女德任被派去查清缘由。",
      "故事以花为线，勾勒出王宫内外四段被遗忘的感情。德任在整理旧档的过程中发现，自己的母亲也曾站在那棵树下。",
      "剧集服化道精致，画面介于古典绘卷与实景之间，结局克制而留白。",
    ],
    tags: ["古装情感", "宫廷", "遗忘", "宿命"],
  },
  {
    id: "dianying-yuan-xinnian",
    title: "电影院的第七排",
    type: "movie",
    genres: ["喜剧", "剧情"],
    region: "中国大陆",
    year: 2021,
    status: "已上线 · 高清版",
    rating: 8.1,
    views: 118000,
    director: "罗一川",
    cast: ["李承泽", "周婉宁", "高致远", "顾南衣"],
    duration: "101 分钟",
    poster: "https://readdy.ai/api/search-image?query=Warm%20comedic%20film%20poster%20of%20a%20row%20of%20cinema%20seats%20with%20a%20popcorn%20bucket%20and%20a%20small%20orange%20lamp%2C%20deep%20navy%20background%20with%20soft%20warm%20highlights%2C%20playful%20minimal%20composition%2C%20no%20text&width=600&height=840&seq=gmw-poster-11&orientation=portrait",
    wide: "https://readdy.ai/api/search-image?query=Retro%20cinema%20lobby%20with%20poster%20frames%20and%20a%20marquee%20of%20warm%20orange%20bulbs%2C%20deep%20navy%20blue%20velvet%20interior%2C%20empty%20and%20cozy%2C%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=gmw-wide-11&orientation=landscape",
    summary: "一张连续买了十年的第七排座位票，牵出了一段没人承认过的暗恋。",
    synopsis: [
      "老影院经理在清理售票系统时发现，有一个会员连续十年买了同一部老片的第七排固定座位，从未取票。",
      "他顺着线索找到了这位顾客——一个每次只在前台站一会儿就走的修表匠。为了弄清原因，经理决定重映那部电影，并把整排座位全部卖出。",
      "影片幽默又温柔，把一个关于陪伴与错过的小故事，讲成了一封写给老影院的情书。",
    ],
    tags: ["温情喜剧", "影院", "暗恋", "小人物"],
  },
  {
    id: "chang-ye-wei-mian",
    title: "长夜未眠",
    type: "tv",
    genres: ["悬疑", "都市"],
    region: "中国香港",
    year: 2022,
    status: "全 16 集 · 完结",
    rating: 8.5,
    views: 207000,
    director: "钟楚言",
    cast: ["钟楚言", "梁世衡", "苏念白"],
    duration: "50 分钟 / 集",
    poster: "https://readdy.ai/api/search-image?query=Noir%20city%20suspense%20poster%20of%20a%20lone%20detective%20silhouette%20under%20a%20streetlight%20in%20heavy%20rain%2C%20deep%20navy%20blue%20night%20with%20warm%20orange%20neon%20reflections%20on%20wet%20asphalt%2C%20vertical%20cinematic%20composition%2C%20no%20text&width=600&height=840&seq=gmw-poster-12&orientation=portrait",
    wide: "https://readdy.ai/api/search-image?query=Hong%20Kong%20street%20at%20midnight%20in%20heavy%20rain%2C%20warm%20orange%20neon%20signs%20reflecting%20in%20wet%20asphalt%2C%20deep%20navy%20blue%20night%20atmosphere%2C%20cinematic%20noir%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=gmw-wide-12&orientation=landscape",
    summary: "连续七晚的同一个报警电话，把一个失眠的警探拖进了这座城市的另一面。",
    synopsis: [
      "警探陈之寒常年失眠，连续七晚他都在凌晨三点接到同一个无声报警。电话来自一间已经倒闭的茶餐厅。",
      "他独自调查，发现每一个相关的人都在这座城市里安静地生活着，没有人愿意提起十年前的那场雨夜。而他自己，似乎是唯一一个不记得那晚发生了什么的当事人。",
      "剧集以冷峻的港式影像风格讲述一个关于记忆与自我欺骗的故事。",
    ],
    tags: ["港式悬疑", "雨夜", "记忆", "警探"],
  },
];